import {FACTION_CONFIGS} from '../../configs/factions';
import {UNIT_TYPES} from '../../configs/units';
import {getFactionIconPath} from '../factions/getFactionIconPath';
import {getFactionSkinIconPath} from '../../configs/factions/skins/allFactionSkins';
import {getFactionUnitSkinIconPath} from '../factions/getFactionUnitSkinIconPath';
import {getFormattedPrice} from '../price/getFormattedPrice';

/**
 * Резолвит КОНКРЕТНУЮ выпавшую награду сундука (объект reward — ровно тот,
 * что возвращает server/utils/chests/openChest.js и хранится как есть в
 * истории открытий) в имя/иконку для отображения. В отличие от
 * resolvePurchaseItemDisplay (тип+id купленного товара), reward.type тут уже
 * несет всю нужную информацию — искать конфиг по itemId не требуется.
 */
export function resolveChestOpeningRewardDisplay(reward) {
  if (!reward) {
    return {name: '—', iconPath: null};
  }

  switch (reward.type) {
    case 'numens':
      return {
        name: getFormattedPrice(reward.amount),
        iconPath: '/img/icons/numens.png',
        isNumens: true,
      };
    case 'crystals':
      return {
        name: getFormattedPrice(reward.amount),
        iconPath: '/img/icons/crystal.png',
        isCrystals: true,
      };
    case 'faction':
      return {
        name: reward.factionName || reward.factionId,
        iconPath: getFactionIconPath(reward.factionId),
      };
    case 'faction_skin':
      return {
        name: reward.skinName || reward.skinId,
        iconPath: getFactionSkinIconPath(reward.skinId),
      };
    case 'faction_unit_skin': {
      const factionConfig = FACTION_CONFIGS.find((f) => f.id === reward.factionId);
      const hasD20 = !factionConfig?.unitTypes || factionConfig.unitTypes.includes(UNIT_TYPES.D20.id);
      const unitTypeId = hasD20 ? UNIT_TYPES.D20.id : UNIT_TYPES.D10.id;
      return {
        name: factionConfig ? `${factionConfig.name} — образ отряда` : (reward.unitSkinId || 'Образ отряда'),
        iconPath: getFactionUnitSkinIconPath(unitTypeId, reward.factionId),
      };
    }
    case 'all_factions':
      return {
        name: 'Все фракции',
        iconPath: '/img/icons/banner.png',
      };
    default:
      return {name: reward.itemType || 'Награда', iconPath: null};
  }
}
